import { render, staticRenderFns } from "./type_3_Info.vue?vue&type=template&id=64e3a262&scoped=true"
import script from "./type_3_Info.vue?vue&type=script&lang=js"
export * from "./type_3_Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3a262",
  null
  
)

export default component.exports